//@ts-nocheck
const normalizeLogoUrl = (value) => {
  if (typeof value !== 'string') {
    return '';
  }

  return value.trim();
};

export const parseTripLogoSetting = (settingValue) => {
  const normalizedValue = normalizeLogoUrl(settingValue);

  if (!normalizedValue) {
    return '';
  }

  try {
    const parsedValue = JSON.parse(normalizedValue);

    if (typeof parsedValue === 'string') {
      return normalizeLogoUrl(parsedValue);
    }

    if (Array.isArray(parsedValue)) {
      const firstValue = parsedValue?.[0];

      return typeof firstValue === 'string'
        ? normalizeLogoUrl(firstValue)
        : normalizeLogoUrl(firstValue?.tripLogoUrl);
    }

    return normalizeLogoUrl(parsedValue?.tripLogoUrl);
  } catch (error) {
    return normalizedValue;
  }
};

export const resolveOperatorLogo = ({
  tripLogoUrl = '',
  globalLogoUrl = '',
  enabled = true
} = {}) => {
  const normalizedGlobalLogoUrl = normalizeLogoUrl(globalLogoUrl);

  if (!enabled) {
    return normalizedGlobalLogoUrl;
  }

  return normalizeLogoUrl(tripLogoUrl) || normalizedGlobalLogoUrl;
};

export const withResolvedOperatorLogo = (
  trip = {},
  { tripLogoUrl = '', enabled = true } = {}
) => {
  const tenant = trip?.tenant || {};
  const resolvedLogoUrl = resolveOperatorLogo({
    tripLogoUrl,
    globalLogoUrl: tenant?.tenantlogo,
    enabled
  });

  return {
    ...trip,
    operatorLogo: {
      tripLogoUrl: enabled ? normalizeLogoUrl(tripLogoUrl) : '',
      globalLogoUrl: normalizeLogoUrl(tenant?.tenantlogo),
      logoUrl: resolvedLogoUrl,
      hasTripLogo: enabled && Boolean(normalizeLogoUrl(tripLogoUrl))
    },
    tenant: {
      ...tenant,
      tenantlogo: resolvedLogoUrl
    }
  };
};
